import { gate } from 'hub-http/gates';
export const GATES = {
  MARKETING_STUDIO_HOME: gate('MarketingStudio:Studio2.0:Home'),
  AGENT_APPROVER: gate('ProductApprovals::AgentApprover'),
  INLINE_APPROVAL_ACTIONS: gate('ProductApprovals::InlineApprovalActions'),
  AGENT_IMPLEMENTING_REQUESTED_CHANGES: gate('ProductApprovals::AgentImplementingRequestedChanges')
};
export const SCOPES = {
  SUPER_ADMIN: 'super-admin',
  PARTNER_ADMIN: 'partner-admin'
};